import React from 'react';

import { cn } from '@/lib/utils';

import { statusConfig } from './StatusBadge.styles';
import type { StatusBadgeProps } from './StatusBadge.types';

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, showDot = true, className, children }) => {
  const config = statusConfig[status?.toUpperCase() ?? ''] || statusConfig.DISABLED;

  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase()}`}
      className={cn(
        'inline-flex items-center gap-1.5 px-2.5 py-1 text-xs font-medium rounded-full border',
        config.bg,
        config.text,
        config.border,
        className
      )}
    >
      {showDot && (
        <span className={cn('w-1.5 h-1.5 rounded-full', config.dot)} />
      )}
      {children || status}
    </span>
  );
};
